<template>
    <MainLayout>
        <div class="container">
            <div class="box">
                <b-button v-if="$hasPermission('mapping.add')" class="float-right" @click="newModel">Nuevo mapeo</b-button>
                <h2>Mapeos</h2>
                <hr>
                <b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'places-index-list') } ">
                    <div class="row pb-3">
                        <b-form-group class="col-2" label="Nombre">
                            <b-form-input v-model="filters.search" type="text" />
                        </b-form-group>
                        <b-form-group class="col-2" label=".">
                            <b-button type="submit" variant="primary">Buscar</b-button>
                        </b-form-group>
                    </div>
                </b-form>
                <AjaxTable id="places-index-list" :columns="modelColumns" :filters="filters" resource="mappings">
					<template #cell(name)="row">
                        <div>
                            {{row.item.name}}
                        </div>
                    </template>
                    <template #cell(actions)="row">
                        <div class="text-center">
                            <b-button  @click="(event) => editModel(row.item)" type="button" size="sm" class="mr-1" variant="info">
                                <md-icon icon="edit" />
                            </b-button>
                            <b-button v-if="$hasPermission('mapping.delete')" @click="(event) => modelDelete(row.item)" type="button" size="sm" class="mr-1" variant="danger">
                                <md-icon icon="delete" />
                            </b-button>
                        </div>
                    </template>
                </AjaxTable>
            </div>
        </div>
		<SingleForm ref="refSingleForm" @successCallback="successCallback"></SingleForm>
    </MainLayout>
</template>

<script>

    import MainLayout from '../layout/MainLayout.vue'
    import AjaxTable from '../../helpers/AjaxTable.vue'
	import SingleForm from './SingleForm.vue'
    // import api from '../../../api.js'

    export default {
        components: {MainLayout, AjaxTable, SingleForm},
        data() {
            return {
				unableEdit: false,
                filters : {
                    search:'',
                },
                modelColumns: [
                    {key: 'id',             label: 'ID'},
					{key: 'name',    label: 'Nombre'},
                    {key: 'description',    label: 'Descripción'},
                    {key: 'status',         label: 'Estatus'},
                    {key: 'actions',        label: 'Acciones'}
                ],
				itemMapping:null,
				loading: false,
            }
        },
		mounted(){
			// api(this).get(`/mapping/service-types/109`).then((response) => {
			// 	console.log(response);
			// }).catch(err => {
			// 	this.$root.handleRequestError(err)
			// });
			// console.log(this.modelColumns);
		},
        methods: {
            successCallback(){
				this.$root.$emit('bv::refresh::table', 'places-index-list')
			},
			editModel(item) {
				this.$refs.refSingleForm.show();
				this.$refs.refSingleForm.setModel(item.id, item.name);
			},
            newModel() {
				// this.unableEdit = false
                // this.$refs['single'].loadModel(-1)
				// this.itemMapping = {
				// 	id: 78,
				// 	name: "Mapeo 102",
				// 	status: "active",
				// 	services: [
				// 		{
				// 			id:2,
				// 			service:'Drive 7-10',
				// 			relate:109,
				// 			flag: ''//update
				// 		},
				// 		{
				// 			id:3,
				// 			service:'Drive 8-20',
				// 			relate:112,
				// 			flag: ''//update
				// 		}
				// 	]
				// }
				// this.$refs.refSingleForm.setModel(this.itemMapping);
				this.$refs.refSingleForm.newModel();
				this.$refs.refSingleForm.show();
            },
            modelDelete(item) {
				this.$bvModal.msgBoxConfirm('¿Realmente desea eliminar el mapeo actual?', {
					title: 'Eliminar',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'Si, continuar',
					cancelTitle: 'NO',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(value => {
					if(value){
						this.loading = true;
						let rParams = {
							url: `/mappings/${item.id}` ,
							method: "delete",
						};
						this.$root.api
							.request(rParams)
							.then((res) => {
								this.loading=false;
								if(res.status == 200 && res.data.error == false) {
									this.$root.showAlert("Mapeo eliminado");
									this.successCallback();
								}else{
									this.$root.showAlert(res.data.message[0], { variant: "danger" });
								}
								console.log(res);
							})
							.catch(()=>{
								this.loading=false;
								this.$root.handleRequestError;
							});
					}
				});

				// this.$root.showWarning({
				// 	okAction: (event, setLoading, close) => {
				// 		setLoading(true)
				// 		api(this).delete(`/locks/${item.id}`).then((response) => {

				// 			if (response.data.error) {
				// 				this.$root.showAlert(response.data.message, {variant: 'warning'})
				// 				close()
				// 				return false
				// 			}

				// 			this.$root.showAlert('Registro Eliminado!', {variant: 'warning'})
				// 			this.$root.$emit('bv::refresh::table', 'places-index-list')
				// 			this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['destinationsOpts'],forceRefresh: true})
				// 			close()
				// 		}).catch(err => {
				// 			this.$root.handleRequestError(err)
				// 			close()
				// 		});
				// 	}
				// })
			},
        }
    }

</script>
